import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('glLedgerService', (http, CacheFactory, config) => new LocalCache({
    provider: () => http.get('/ledger'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.ledger,
    cacheName: 'ledger',
  })
);